<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 09:52:49
 * @LastEditTime: 2020-09-21 15:14:09
 * @Description: 填空题
 -->
<template>
  <div class="text">
    <div class="title">
      <span>{{ title }}</span>
      <div
        v-if="stemMediaInfoVO.mediaPath"
        class="look-media"
        @click="lookMedia(stemMediaInfoVO)">查看多媒体</div>
    </div>
    <div class="list">
      <i-input
        v-for="(answer, index) in userAnswers"
        :key="index" :value="answer" size="small" readonly>
        <span slot="prepend">{{ index + 1 }}</span>
      </i-input>
    </div>
    <div class="analysis">
      <div class="analysis-left">
        <p>正确答案：{{ correctAnswer }}</p>
        <p>解析说明：{{ tip !== undefined ? tip : '无' }}</p>
      </div>
      <div class="analysis-right" v-if="status === '已统分'">
        <div :class="[correct ? 'correct' : 'error']">
          {{ correct ? '正确' : '错误' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextQuestion',
  props: {
    status: { type: String, required: true },
    index: { type: Number, required: true },
    question: { type: Object, required: true },
  },
  data() {
    return {
      showTitle: '',
      userAnswers: [],
      correctAnswer: [],
    };
  },
  computed: {
    title() {
      return `${this.index + 1}、${this.question.content}（${this.question.totalScore}分）`;
    },
    options() {
      return this.question.options;
    },
    correct() {
      return this.question.correct;
    },
    userAnswer() {
      return this.question.userAnswer;
    },
    tip() {
      return this.question.tip;
    },
    stemMediaInfoVO() {
      return this.question.mediaInfoVO ? this.question.mediaInfoVO : {};
    },
  },
  watch: {
    options: {
      immediate: true,
      handler(options) {
        const correctAnswer = [];
        options.forEach((option) => {
          if (option.correct) {
            correctAnswer.push(option.content);
          }
        });

        this.correctAnswer = correctAnswer.join('、');
      },
    },
    title: {
      immediate: true,
      handler(title) {
        this.showTitle = title.replace(/\[\]/g, '__');
      },
    },
    userAnswer: {
      immediate: true,
      handler(userAnswer) {
        if (!userAnswer) {
          userAnswer = '';
        }

        const userAnswers = userAnswer.split(']');

        this.userAnswers = userAnswers;
      },
    },
  },
  methods: {
    lookMedia({ mediaContentType, mediaPath, videoCover }) {
      this.$emit('preview-media', { mediaContentType, mediaPath, videoCover });
    },
  },
};
</script>

<style lang="less" scoped>
.text {
  width: 100%;

  > .title {
    margin-bottom: 16px;
  }

  > .list {
    /deep/ .ivu-input-group {
      margin-bottom: 6px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  > .analysis {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    padding: 6px 10px;
    background-color: #fbf9fb;

    > .analysis-left {
      > p {
        line-height: 26px;
      }
    }

    > .analysis-right {
      display: flex;
      align-items: center;

      /deep/ .ivu-input-number {
        margin-top: 6px;
        width: 60px;
      }
      >.error{
        width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #ed4014;
      }
      >.correct{
       width: 42px;
        height: 24px;
        font-size: 13px;
        color: #fff;
        line-height: 24px;
        text-align: center;
        background-color: #2d8cf0;
      }
    }
  }

  .look-media {
    display: inline-block;
    color: #0C8CCA;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
    background-color: rgba(12, 140, 202, .1);
    border-radius: 6px;
    line-height: normal;
  }
}
</style>
